module.exports = __webpack_public_path__ + "/img/DFN-2-DcpRtF.svg";